// extracted by mini-css-extract-plugin
export default {"wrapper":"MultipleOverviewConfig_wrapper__nZl8n","saveButton":"MultipleOverviewConfig_saveButton__a2I3a"};